var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_218)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.1578,
    y: 10.953,
    width: 64.61,
    height: 64.61,
    rx: 32.305,
    fill: "#141726"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.918 69.1929C60.9902 69.1929 72.398 57.7851 72.398 43.7129C72.398 29.6407 60.9902 18.2329 46.918 18.2329C32.8458 18.2329 21.438 29.6407 21.438 43.7129C21.438 57.7851 32.8458 69.1929 46.918 69.1929Z",
    fill: "#141726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5808 54.4719C51.3256 47.5604 44.9811 43.6429 37.146 42.0122C34.3751 41.4389 31.5914 41.4452 28.9032 42.5026C27.0623 43.2288 26.782 43.9932 27.6483 45.9233C33.5342 44.5283 39.0124 45.8278 44.1403 48.7898C49.3063 51.7774 53.1602 55.937 54.9119 61.8483C57.3708 61.0967 57.6893 60.6826 57.0969 58.3958C56.7465 57.0517 56.307 55.6503 55.5808 54.4719Z",
    fill: "url(#paint0_linear_2_218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2378 48.8471C54.7724 40.8846 47.0328 36.4319 37.5734 34.9414C35.07 34.5464 32.5156 34.6547 30.1714 35.8523C29.0503 36.4256 28.0566 37.1581 27.7891 38.7124C35.1655 36.6804 41.784 38.4767 48.0138 42.0885C54.2755 45.7194 59.1677 50.5925 61.0723 58.0836C62.3973 56.9115 62.633 55.4719 62.289 54.1342C61.8176 52.2996 61.2825 50.3695 60.2378 48.8471Z",
    fill: "url(#paint1_linear_2_218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1261 49.3567C28.5911 50.3886 28.8969 51.5543 29.5912 52.3888C29.9415 52.8156 31.0053 52.65 31.7443 52.7519C31.8589 52.7646 31.9736 52.7837 32.0882 52.7965C38.643 53.7711 43.8154 56.9433 47.51 62.4789C47.7266 62.8037 48.0769 63.2879 48.3636 63.2879C49.472 63.2815 50.5867 63.1095 51.7078 63.0012C50.0389 53.7456 36.267 46.1526 28.1261 49.3567Z",
    fill: "url(#paint2_linear_2_218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2632 41.5916C59.6514 36.5402 54.6701 33.1768 49.0135 30.7817C45.096 29.1191 41.0383 28.1191 36.7322 28.635C35.2416 28.8134 33.8466 29.2402 32.6936 30.2084C47.4019 30.5779 58.4666 36.9479 66.0724 49.5286C66.0851 48.6942 66.2125 47.7641 65.9068 47.0125C65.1424 45.1461 64.4162 43.2032 63.2632 41.5916Z",
    fill: "url(#paint3_linear_2_218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6516 38.9545C63.6577 27.5586 51.491 22.074 42.4966 24.8513C52.1854 26.7623 60.1351 31.3806 66.6516 38.9545Z",
    fill: "url(#paint4_linear_2_218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3368 55.4276C34.8148 59.842 39.2356 62.4155 44.9049 63.2499C42.7391 59.205 35.1078 54.8288 31.3368 55.4276Z",
    fill: "url(#paint5_linear_2_218)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_218",
    x: 0.507836,
    y: 0.943002,
    width: 91.91,
    height: 91.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.64
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.825
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_218",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_218",
    x1: 58.0604,
    y1: 26.7768,
    x2: 37.2687,
    y2: 60.1276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C6F462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#33D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_218",
    x1: 57.9121,
    y1: 26.6839,
    x2: 37.1211,
    y2: 60.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C6F462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#33D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_218",
    x1: 58.1934,
    y1: 26.8599,
    x2: 37.4024,
    y2: 60.2107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C6F462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#33D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_218",
    x1: 57.6848,
    y1: 26.5424,
    x2: 36.8932,
    y2: 59.8931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C6F462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#33D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_218",
    x1: 57.8545,
    y1: 26.6482,
    x2: 37.0628,
    y2: 59.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C6F462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#33D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_218",
    x1: 58.3225,
    y1: 26.9402,
    x2: 37.5315,
    y2: 60.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C6F462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#33D9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_218"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.438,
    y: 18.2329,
    width: 50.96,
    height: 50.96,
    rx: 25.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJup);
export default __webpack_public_path__ + "static/media/jup.0918079d573690e9c7828ed0aa0b37c3.svg";
export { ForwardRef as ReactComponent };